// extracted by mini-css-extract-plugin
module.exports = {"container":"Label_container__2d8n7","text_item":"Label_text_item__3biFz","text_content":"Label_text_content__1fHgZ"};